import { OwnerFilter } from '@/api/owner/types';
import { AdmittedFilter } from "@/constants/owner";

export default {
  ownerAdmittedContext: null,
  ownerAdmittedStatus: '',
  ownerContext: null,
  status: '',
  errorContext: null,
  ownersContext: null,
  ownersStatus: '',
  ownersFilter: !!localStorage.getItem('_owners_filter') ? Object.assign({}, JSON.parse(localStorage.getItem('_owners_filter')!), {onlyUserOwners: false}) : { onlyUserOwners: false, admitted: AdmittedFilter.ALL } as OwnerFilter,
};
